import { ToastState } from './types'

const state = new ToastState()

export { state }
